// extracted by mini-css-extract-plugin
export var charityItem = "styles-module--charity-item--2aBDI";
export var charityImage = "styles-module--charity-image--nvQ5a";